// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mr-0";